/**
 * applyBrandTheme(brand) — write the brand's colors + glass tokens onto
 * :root as CSS custom properties.
 *
 * Extracted from App.js (2026-07-17) so it can run BOTH:
 *   1. synchronously at store-init time (src/context/GlobalState.js), before
 *      React's first paint — kills the "Ocean Teal default → brand colors"
 *      flash on first load, and
 *   2. reactively from App.js when state.brand changes at runtime.
 * Idempotent; safe to call repeatedly.
 */
export function applyBrandTheme(brand) {
  const colors = brand && brand.colors;
  if (!colors || typeof document === 'undefined') return;
  const root = document.documentElement;
  root.style.setProperty('--color-primary', colors.primary);
  root.style.setProperty('--color-primary-light', colors.primaryLight);
  root.style.setProperty('--color-accent', colors.accent);
  root.style.setProperty('--color-accent-light', colors.accentLight);
  root.style.setProperty('--color-bg', colors.background);
  root.style.setProperty('--color-bg-alt', colors.backgroundAlt);
  root.style.setProperty('--color-text', colors.text);
  root.style.setProperty('--color-text-secondary', colors.textSecondary);
  root.style.setProperty('--color-border', colors.border);
  root.style.setProperty('--color-success', colors.success);
  root.style.setProperty('--color-warning', colors.warning);
  // Footer color
  if (colors.footer) {
    root.style.setProperty('--color-footer', colors.footer);
  }
  // RGB values for glassmorphism
  if (colors.primaryRgb) {
    root.style.setProperty('--color-primary-rgb', colors.primaryRgb);
  }
  if (colors.accentRgb) {
    root.style.setProperty('--color-accent-rgb', colors.accentRgb);
  }
  // Glass vars
  const glass = brand && brand.glass;
  if (glass) {
    root.style.setProperty('--glass-primary-rgb', glass.primaryRgb);
    root.style.setProperty('--glass-accent-rgb', glass.accentRgb);
    root.style.setProperty('--glass-hero-overlay', glass.heroOverlay);
    root.style.setProperty('--glass-nav-blur', glass.navBlur);
    root.style.setProperty('--glass-card-blur', glass.cardBlur);
    // Hero CTA button colors (contrasting against hero overlay)
    if (glass.heroCta) {
      root.style.setProperty('--hero-cta-bg', glass.heroCta.bg);
      root.style.setProperty('--hero-cta-text', glass.heroCta.text);
      root.style.setProperty('--hero-cta-hover-bg', glass.heroCta.hoverBg);
      root.style.setProperty('--hero-cta-hover-text', glass.heroCta.hoverText || glass.heroCta.text);
    } else {
      root.style.setProperty('--hero-cta-bg', 'var(--color-accent)');
      root.style.setProperty('--hero-cta-text', '#ffffff');
      root.style.setProperty('--hero-cta-hover-bg', '#c53030');
      root.style.setProperty('--hero-cta-hover-text', '#ffffff');
    }
  }
}
